// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"vA","hide":"vB"};